// src/pages/Location.jsx
import React, {
  useEffect,
  useState
} from "react";

import {
  useParams
} from "react-router-dom";

import api from "../api";

export default function Location() {

  const { id } = useParams();

  const [location, setLocation] =
    useState(null);

  const [posts, setPosts] =
  useState([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {

    loadLocation();

  }, [id]);

  async function loadLocation() {

    try {

      setLoading(true);

      const { data } =
  await api.get(
    `/locations/${id}/posts`
  );

setLocation(data.location);

setPosts(
  data.posts || []
);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }

  }

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div
      className="page-shell"
      style={{
        padding: 16,
        maxWidth: 800,
        margin: "0 auto"
      }}
    >
      <h1>
        📍 {location?.name}
      </h1>

      <h3>
  Posts from this location
</h3>

<div
  style={{
    color: "#888",
    marginBottom: 12
  }}
>
  {posts.length} post
  {posts.length !== 1 ? "s" : ""}
</div>

{posts.length === 0 && (
  <p>
    No posts from this location yet.
  </p>
)}

{posts.map((post) => (
  <div
    key={post.id}
    style={{
      border: "1px solid #2a2f3a",
      borderRadius: 12,
      padding: 12,
      marginBottom: 12
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8
      }}
    >
      {post.profile_pic_url && (
        <img
          src={post.profile_pic_url}
          alt=""
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
      )}

      <strong>
        {post.username}
      </strong>
    </div>

    {post.text && (
      <div
        style={{
          marginTop: 8
        }}
      >
        {post.text}
      </div>
    )}

    <div
      style={{
        marginTop: 8,
        fontSize: 12,
        color: "#888"
      }}
    >
      {new Date(
        post.created_at
      ).toLocaleString()}
    </div>
  </div>
))}
    </div>
  );

}